module.exports = __webpack_public_path__ + "img/ModernCosmeticsBookGift.7a73a85f.png";